import { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { addAlpha } from '@algoan/deep-dive/theme';
import { useClickAwayListener } from '@algoan/dashboard/utils';
import { ArrowIcon } from '../../icons';
import { ListItem } from '../list-item';

/**
 * @deprecated
 */
export interface DeprecatedDropdownItem {
  display: string;
  value: string;
}

type Variant = 'primary' | 'secondary';

/**
 * @deprecated
 */
export interface DeprecatedSelectDropdownProps {
  className?: string;
  itemRenderer?: (option: DeprecatedDropdownItem) => React.ReactNode;
  onClick: (option: DeprecatedDropdownItem) => void;
  options: DeprecatedDropdownItem[];
  placeholder?: string;
  testAttribute?: string;
  variant?: Variant;
  value: DeprecatedDropdownItem;
}

/**
 * @deprecated
 */
export const DeprecatedSelectDropdown: React.FC<DeprecatedSelectDropdownProps> = ({
  className,
  itemRenderer,
  onClick,
  options,
  placeholder = '...',
  testAttribute,
  value,
  variant = 'primary',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = (): void => setIsOpen(!isOpen);
  const dropdownContainerRef = useClickAwayListener<HTMLDivElement>(() => {
    setIsOpen(false);
  });
  const theme = useTheme();

  return (
    <DeprecatedStyle.DropdownContainer
      ref={dropdownContainerRef}
      data-testid={testAttribute}
      onClick={() => toggleDropdown()}
      variant={variant}
      className={className}
      data-is-selected={isOpen}
    >
      <DeprecatedStyle.DropdownSelected variant={variant} isPlaceholder={!Boolean(value.value)}>
        {itemRenderer ? itemRenderer(value) : value.value ? value.display : placeholder}
      </DeprecatedStyle.DropdownSelected>
      <DeprecatedStyle.ArrowContainer variant={variant}>
        <DeprecatedStyle.ArrowIcon size="large" direction={isOpen ? 'up' : 'down'} color={theme.secondary.softBlue1} />
      </DeprecatedStyle.ArrowContainer>
      {isOpen && (
        <DeprecatedStyle.DropdownListContainer variant={variant}>
          <DeprecatedStyle.DropdownList variant={variant}>
            {options.map((option: DeprecatedDropdownItem) => (
              <DeprecatedStyle.ListItem data-testid={option.value} onClick={() => onClick(option)} key={option.value}>
                {itemRenderer ? itemRenderer(option) : option.display}
              </DeprecatedStyle.ListItem>
            ))}
          </DeprecatedStyle.DropdownList>
        </DeprecatedStyle.DropdownListContainer>
      )}
    </DeprecatedStyle.DropdownContainer>
  );
};

/**
 * @deprecated
 */
export const DeprecatedStyle = {
  DropdownContainer: styled.div<{ variant: Variant }>`
    border: 1px solid ${(props) => props.theme.legacy.secondary};
    box-sizing: border-box;
    position: relative;
    ${({ variant }) => {
      switch (variant) {
        case 'primary':
          return `
          border-radius:8px;
          height: 45px;
          `;
        case 'secondary':
          return `
            border-radius:6px;
            height: 30px;
            width:245px;
            `;
      }
    }}
  `,
  ArrowContainer: styled.div<{ variant: Variant }>`
    margin-top: 7px;
    position: absolute;
    ${({ variant }) => {
      switch (variant) {
        case 'primary':
          return `
          top: 7px;
          right: 13px
          `;
        case 'secondary':
          return `
          top: 0px;
          right: 30px
          `;
      }
    }}
  `,
  DropdownSelected: styled.div<{ variant: Variant; isPlaceholder: boolean }>`
    font-weight: 400;
    color: ${(props) => (props.isPlaceholder ? props.theme.legacy.secondary : props.theme.algoanBlue)};
    &:hover {
      cursor: pointer;
    }
    ${({ variant }) => {
      switch (variant) {
        case 'primary':
          return `
          font-size: 14px;
          padding: 13px 15px;
          `;
        case 'secondary':
          return `
          font-size: 12px;
          padding: 7px 15px;
          `;
      }
    }}
  `,
  DropdownListContainer: styled.div<{ variant: Variant }>`
    position: relative;
    z-index: 1;
    ${({ variant }) => {
      switch (variant) {
        case 'secondary':
          return `width: 245px`;
        case 'primary':
      }
    }}
  `,
  DropdownList: styled.ul<{ variant: Variant }>`
    padding: 0;
    margin-top: 8px;
    background: #ffffff;
    box-shadow: 0px 3px 18px ${(props) => addAlpha(props.theme.algoanBlue, 0.15)};
    color: ${(props) => props.theme.algoanBlue};
    font-size: 12px;
    font-weight: 400;
    padding-top: 10px;
    padding-bottom: 1px;
    border-radius: 4px;
    ${({ variant }) => {
      switch (variant) {
        case 'primary':
          return `font-size: 14px;`;
        case 'secondary':
          return `font-size: 12px;`;
      }
    }}
  `,
  ListItem: styled(ListItem)``,
  ArrowIcon: styled(ArrowIcon)``,
};
